<template>
  <div class="pb-2">
    <Component :is="isNotForm ? 'div' : 'form'" class="space-y-6" @submit.prevent="submitChallenge()">
      <TwoFactorChallenge v-model:code="form.code" v-model:recovery-code="form.recoveryCode" />
      <FormButton v-if="!isNotForm" type="submit" size="full" color="gradient" :loading="form.loading">Submit Code</FormButton>
    </Component>
  </div>
</template>

<script setup>
import {useAccountStore} from "../stores/AccountStore";
import {reactive} from "vue";
import {redirectToDashboardIfAuthenticated} from "../helpers/Redirects";
import FormButton from "../components/FormButton.vue";
import TwoFactorChallenge from "../components/TwoFactorChallenge.vue";
import {useRouter} from "vue-router";

const emits = defineEmits(["loading"]);
const props = defineProps({
  customSuccessHandler: {
    type: Function,
    default: null,
  },
  isNotForm: Boolean,
});

const accountStore = useAccountStore();

const router = useRouter();
const form = reactive({
  code: "",
  recoveryCode: "",
  loading: false,
});

const submitChallenge = () => {
  if (accountStore.isLoggedIn) redirectToDashboardIfAuthenticated(router);

  form.loading = true;
  emits("loading", true);
  window.progressBar.start();
  accountStore.twoFactorChallenge({code: form.code, recoveryCode: form.recoveryCode})
    .then(async () => {
      if (props.customSuccessHandler) {
        await accountStore.fetchUserAccount();
        props.customSuccessHandler();
      } else await redirectToDashboardIfAuthenticated(router);
    })
    .finally(() => {
      window.progressBar.complete();
      form.loading = false;
      emits("loading", false);
    });
};

if (!props.customSuccessHandler) redirectToDashboardIfAuthenticated(router);

defineExpose({
  submitChallenge,
});
</script>
